export const categories = [
  { id: 'recommend', name: '热门推荐', description: '最受欢迎的韩国漫画推荐', count: 128, icon: 'ri-fire-line' },
  { id: 'romance', name: '恋爱漫画', description: '甜蜜浪漫的韩漫恋爱故事', count: 86, icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻漫画', description: '充满想象力的奇幻世界', count: 74, icon: 'ri-magic-line' },
  { id: 'action', name: '动作漫画', description: '热血沸腾的动作大片', count: 63, icon: 'ri-sword-line' },
  { id: 'comedy', name: '搞笑漫画', description: '轻松幽默的搞笑日常', count: 52, icon: 'ri-emotion-laugh-line' },
  { id: 'suspense', name: '悬疑漫画', description: '扣人心弦的悬疑推理', count: 41, icon: 'ri-search-eye-line' },
  { id: 'bl', name: 'BL漫画', description: '人气BL韩漫作品合集', count: 68, icon: 'ri-user-heart-line' },
  { id: 'gl', name: 'GL漫画', description: '精选GL韩漫推荐', count: 35, icon: 'ri-women-line' },
  { id: 'drama', name: '剧情漫画', description: '深度剧情引人入胜', count: 57, icon: 'ri-book-open-line' },
  { id: 'horror', name: '恐怖漫画', description: '惊悚刺激的恐怖韩漫', count: 29, icon: 'ri-ghost-line' },
  { id: 'daily', name: '日常漫画', description: '温暖治愈的日常故事', count: 44, icon: 'ri-sun-line' },
  { id: 'complete', name: '已完结', description: '已完结的优质韩漫作品', count: 93, icon: 'ri-check-double-line' },
];